import Component from "@tunnel-components/@sharded/@widgets/scrollbars/component";
import * as React from "react";
// import * as Lodash from 'lodash';
import { connect } from "react-redux";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @method componentDidUpdate
 * @method componentWillReceiveProps
 * @method render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      scrollTop: 0,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    // this.handleScroll = this.handleScroll.bind(this);
  }
  /**
   * @method handleScroll
   * @param { any }    event
   * @infos "https://reactjs.org"
   */
  /* public handleScroll = (event : any) => {

        /**
         * @affectation
         * @description : 
         * Affectation par décomposition des élements de l'objet (props)
         * les élements existent ou sont créés dans ( ou par) la @class container
         * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
         * susceptibles de subir une affectation par décomposition
         * exemple : const { elements } = objet ;
         * @infos "https://developer.mozilla.org"
         */

  // const { scrollTop } = event;

  //  { /** Empêcher la mutation du state */}
  // this.setState((state: any) => ({ scrollTop }));

  // };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.scrollTop !== this.state.scrollTop) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ scrollTop: this.state.scrollTop }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.state}
        {...this.props}
        // handleScroll={this.handleScroll}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {};
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/scrollbars/container.tsx